import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchOneHourAverage,fetchKMLDownloadData } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const OneHourAverageChartSlice: Slice<any, {}, "OneHourAverageChartSlice"> = createSlice({
    name: "OneHourAverageChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchOneHourAverage.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchOneHourAverage.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchOneHourAverage.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export const DowloadKMLSlice: Slice<any, {}, "DownloadKMLSlice"> = createSlice({
    name: "DownloadKMLSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchKMLDownloadData.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchKMLDownloadData.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchKMLDownloadData.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default OneHourAverageChartSlice;
